export const isNonMaterialProject = (projectJson) => {
  return projectJson.materialVersion === undefined;
}